import React, {useState, useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {useMediaQuery } from 'react-responsive';
import {Link, useHistory} from "react-router-dom";
import {getProject, getProjectFavorites} from "../../../actions/projects"
import {toggleSidebar} from "../../../actions/core";
import NotificationBar from "./NotificationBar";
import SidebarPageLink from "./SidebarPageLink"
import SvgDashboard from "../../iconComponents/IconDashboard";
import SvgInvoices from "../../iconComponents/IconInvoices";
import SvgPeople from "../../iconComponents/IconPeople";
import SvgProjects from "../../iconComponents/IconProjects";
import SvgNotification from "../../iconComponents/IconNotificationBell";
import SvgSettings from "../../iconComponents/IconSettings";
import SvgContracts from "../../iconComponents/IconContract";

export function Sidebar (props) {
    
    const core = useSelector((state) => state.core);
    const activeProject = useSelector((state) => state.projects.project);
    const status = useSelector((state) => state.auth.status);
    const project_favorites = useSelector((state) => state.projects.project_favorites);

    const [notifOpen, setNotifOpen] = useState(false);

    const isTabletOrMobile = useMediaQuery({query: '(max-width: 768px)'});
    const sidebarIsOpen = (core.sidebarIsDefault && !isTabletOrMobile) || (!core.sidebarIsDefault && isTabletOrMobile);
    const orderedProjectFavorites = project_favorites.sort((a, b) => a.project_name.localeCompare(b.project_name));
    const contractsLink = activeProject.project_id ? `/contracts/contractlist/${activeProject.project_id}` : "/contracts/contractlist/all";
    const unreadCount = core.notifications.length > 0 ? core.notifications.filter(notification => !notification.read).length : 0;

    // when sidebar mounts, get project favourites loaded to redux store
    useEffect(() => { 
        status === "authenticated" && props.getProjectFavorites();
    }, [status])

    const toNotification = (link) => {
        history.push(link);
    }

    return (
        <>
            {status === "authenticated" &&
                <div className={"sidepanel " + (!sidebarIsOpen && "min")}>
                    <div className="sp-content">
                        {notifOpen && <div className="notif-backdrop" onClick={() => setNotifOpen(!notifOpen)}></div>}   
                        <ul> 
                            <SidebarPageLink 
                                title="Settings"
                                id="settings"
                                path="/settings/view"
                                icon={SvgSettings}
                            />
                            <li id="notifications" className="sp-linkwrap" onClick={() => setNotifOpen(!notifOpen)}>
                                <div className={notifOpen ? "sp-link g2-text ": "sp-link g5-text"}>            
                                    <NotificationBar notifOpen={notifOpen} toggleNotif={() => setNotifOpen(!notifOpen)} toNotification={toNotification} /> 
                                    <div className="sp-linkclip">
                                        <SvgNotification pathClass={notifOpen ? "g3-fill" : "g55-fill" } className="sp-icon" height="22px"/>
                                        <span className={sidebarIsOpen ? "sp-text" : "sp-text min"}>Notifications&nbsp;&nbsp;</span>
                                        {unreadCount > 0 && <span className="alert-count p content2 light">{unreadCount}</span>}
                                    </div>
                                </div>
                            </li>
                            <SidebarPageLink 
                                title="Dashboard"
                                id="dashboard"
                                path="/dashboard"
                                icon={SvgDashboard}
                            />
                            <SidebarPageLink 
                                title="People"
                                id="people"
                                path="/people"
                                icon={SvgPeople}
                            />
                            <SidebarPageLink
                                title="Invoice Management"
                                id="mng"
                                path="/mng/projects/list"
                                icon={SvgInvoices}
                            />
                            <SidebarPageLink
                                title="Quotes"
                                id="quotes"
                                path="/quotes/list"
                                icon={SvgContracts}
                            />
                            {/* <SidebarPageLink
                                title="Contracts"
                                id="contracts"
                                path={contractsLink}
                                icon={SvgContracts}
                            /> */}
                        </ul>
                        {orderedProjectFavorites.length > 0 && <hr  className={sidebarIsOpen ? "sp-border" : "sp-border min"} />}
                        <ul className="sp3-ul" id="proj_fav_list">      
                            {orderedProjectFavorites.length > 0 && orderedProjectFavorites.map((item, index) => {
                                return (            
                                    <li key={item.project_id}>
                                        <Link 
                                            to={`/mng/project/view/${item.project_id}`}
                                            className={sidebarIsOpen ? (item.project_id === activeProject.project_id ? "sp3-text active g2-text" : "sp3-text g5-text") : "sp3-text min" }>
                                            <span>{item.project_name}</span>
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            }
        </>
    ) 
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {getProjectFavorites, getProject, toggleSidebar})(Sidebar);